// extracted by mini-css-extract-plugin
export default {"delete-modal":"delete-modal","modal-body":"modal-body"};